import { render, staticRenderFns } from "./RankingNubmer.vue?vue&type=template&id=bb875a5a&scoped=true&"
import script from "./RankingNubmer.vue?vue&type=script&lang=js&"
export * from "./RankingNubmer.vue?vue&type=script&lang=js&"
import style0 from "./RankingNubmer.vue?vue&type=style&index=0&id=bb875a5a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb875a5a",
  null
  
)

export default component.exports